// 法人情報編集完了
import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { Button } from 'react-bootstrap';
import { handleBrowserBack } from '../../../BrowserBack';

const CorporateInfoEditComplete = () => {
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  /**
   * 【法人一覧へ】ボタンを押したときの処理
   */
  const handleClickCorporateList = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/staff/corporate`);
  };

  return (
    <div className="corporate">
      <div className="title">法人情報</div>
      <div className="container">
        <div className="contents">
          <p className="contents_title mb-5">法人情報編集(完了)</p>
          <div className="message_wrapper">
            <p className="text-center m-0">法人情報の編集が完了しました。</p>
          </div>
          <div className="d-flex justify-content-center mb-4">
            <Button className="btn-mini btn-success" onClick={handleClickCorporateList}>
              法人一覧へ
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

if (document.getElementById('corporate-info-edit-complete')) {
  render(<CorporateInfoEditComplete />, document.getElementById('corporate-info-edit-complete'));
}
